import { render, staticRenderFns } from "./ExpressTakeOverList.vue?vue&type=template&id=4e153c0a&scoped=true"
import script from "./ExpressTakeOverList.vue?vue&type=script&lang=js"
export * from "./ExpressTakeOverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e153c0a",
  null
  
)

export default component.exports